import React from 'react';

const UserManagementPage: React.FC = () => {
  return (
    <div>
      <h1>User Management</h1>
      <p>User management page (Admin only) - to be implemented</p>
    </div>
  );
};

export default UserManagementPage;
